var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconGrayDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.602,
    height: 21.553,
    viewBox: "0 0 21.602 21.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-search-1534856",
    transform: "translate(-7.8 -5.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9630",
    "data-name": "Path 9630",
    d: "M23.94,20.415a9.04,9.04,0,1,0-7.111,3.445,9.115,9.115,0,0,0,5.585-1.944l5.437,5.437L29.4,25.8Zm-7.111,1.3a6.84,6.84,0,1,1,6.84-6.84A6.857,6.857,0,0,1,16.83,21.719Z",
    fill: "#253845"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconGrayDark);
export default __webpack_public_path__ + "static/media/search-icon-gray-dark.b1837af61d9d08690f07dce0720f3ae9.svg";
export { ForwardRef as ReactComponent };